import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DxButtonModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule, DxToastModule} from 'devextreme-angular';
import {CommonModule} from '@angular/common';
import {CtlSablonComponent} from '../ctl-sablon/ctl-sablon.component';
import {LabelMode} from 'devextreme/common';
import {UtilsService} from '../../../services/utils.service';
import {OrtakService} from '../../../services/ortak.service';
import {VGenBirimService} from './ctl-vgen-birim.service';
import {CtlVgenBirimAramaComponent} from './ctl-vgen-birim-arama/ctl-vgen-birim-arama.component';


@Component({
  selector: 'dk-ctl-vgen-birim',
  standalone: true,
  imports: [
    DxTextBoxModule,
    DxButtonModule,
    CtlVgenBirimAramaComponent,
    CommonModule,
    DxPopupModule,
    DxScrollViewModule,
    CtlSablonComponent,
    DxToastModule
  ],
  providers: [VGenBirimService],
  templateUrl: './ctl-vgen-birim.component.html',
  styleUrls: ['./ctl-vgen-birim.component.scss'],
})
export class CtlVgenBirimComponent implements OnInit {
   @ViewChild(CtlSablonComponent) ctlSablonComponent: CtlSablonComponent;
  @Input() labelText = "";
  @Input() labelMode: LabelMode = null;
  public crudPopupVisible = false;
  public title!: string;
  @Input() isReadOnly = false;
  @Input() isBindCheck = false;
  @Input() isYetkili = false;
  @Input() validationRulesMap: any[] = [];
  @Input() validationV2 = false;
  public data: any;
  public checkedData: any;
  public toastVisible = false;
  public toastMessage = "Bu birim kullanılıyor. Bir önceki ekrandan düzenleyebilir veya farklı bir birim seçebilirsiniz.";
  public isFirst = true;
  public control!: any;
  controlName = "vGenBirimSrch";
  @Input() code: any;
  @Input() checkData = false;
  @Input() birimTuru: string;
  @Input() isActive = false;
  @Input() isGelenBelge = false;
  @Input() isShowIcBirimler = true;
  @Input() isOnlyGrid = false;
  @Input() isCompulsory = false;
  @Input() notInIcBirimler = false;
  @Input() warningMessage: string | null = null;

  @Output() public dataResult: EventEmitter<any> = new EventEmitter();

  constructor(private service: VGenBirimService, private utilsService: UtilsService, private ortakService: OrtakService) {
  }

  ngOnInit(): void {
    if (this.isGelenBelge) this.birimTuru = "I"
    if (this.controlName) {
      this.getControl();
    }
    if (this.birimTuru || this.checkData) this.service.setParams(this.birimTuru, this.checkData, this.isActive, this.isYetkili,this.isReadOnly,this.isBindCheck)
    if (this.isYetkili) this.service.setParams(this.birimTuru, this.checkData, this.isActive, this.isYetkili,this.isReadOnly,this.isBindCheck)
  }
      ngOnChanges(changes: SimpleChanges) {
           
        if (changes['isReadOnly'] || changes['isBindCheck']) {
      this.service.setParams(this.birimTuru, this.checkData, this.isActive, this.isYetkili,this.isReadOnly,this.isBindCheck)
          }
      }


  getControl() {
    this.ortakService.getControl(this.controlName)
      .subscribe((data) => {
        this.control = data?.controlMetadata;
        //this.service.getDlist(this.control?.dlistCode);
        this.service._gridControlsList.next(data?.controlMetadata.dlistMetadata)
        //if(this.labelText === "")this.labelText = this.control.controlDescription;
        if (data?.controlMetadata.dlistMetadata.baseEntity) {
          if (this.labelText === "") this.labelText = this.control.controlDescription;
          if (this.isCompulsory || this.code) this.getData(this.code, this.birimTuru, true);
        }
      });
  }

  searchClick() {
    this.crudPopupVisible = true
  }

  clear() {
    this.title = '';
    this.code = '';
    this.data = null;
    this.dataResult.emit(null);
  }


  handleValueChange(e: any) {
    if (e === '' || e === null) this.clear();
    else this.getData(e, this.birimTuru);
  }

  getData(code: any, birimTuru: string, isSetData?: boolean) {
    if (this.checkData) {
      this.checkedData = this.service.getCheckData(Number(code));
      this.checkedData.load().done((result: any) => {
        if (result.length > 0) {
          this.toastVisible = true
          return
        } else if (result[0].Kod === code) return
        else if (this.isGelenBelge) this.getDataWithCode(code, birimTuru, isSetData)
      });
    } else this.getDataWithCode(code, birimTuru, isSetData)


  }

  getDataWithCode(code: any, birimTuru: string, isSetData?: boolean) {
    if (code) this.data = this.service.getData(Number(code),this.control, birimTuru, this.control?.dlistMetadata?.baseEntity, isSetData);
    else if (this.isCompulsory) this.data = this.service.getData(null,this.control, birimTuru, this.control?.dlistMetadata?.baseEntity, isSetData);
    else if (this.isGelenBelge) this.data = this.service.getData(null,this.control, 'I', this.control?.dlistMetadata?.baseEntity, isSetData);

    this.data.load().done((result: any) => {
      if (result.length > 0) {
        this.title = result[0].Ad;
        this.code = result[0].Kod;
        this.dataResult.emit(result[0]);
      } else if (this.code.length > 0) {
        this.utilsService.showError('Bulunamadı');
        this.clear();
      }
    });
  }

  closePopupAfter(result: any, sablonCmp: CtlSablonComponent) {
    if (result?.data) {
      this.data = result.data;
      this.code = result.data.Kod;
      this.dataResult.emit(this.data);
    }
    this.crudPopupVisible = false;
    setTimeout(() => {
      sablonCmp.focusInput();
    });
  }
}


